<div class="surface-0">
  <div
    class="flex align-items-center justify-content-between flex-column h-screen"
  >
    <div
      class="flex flex-column align-items-center justify-content-center w-full md:w-4 h-full text-center py-6 px-4"
    >
      <a class="mb-6">
        <img
          src="../../../assets/layout/images/logo-192x192.png"
          alt=""
          srcset=""
        />
      </a>
      <form [formGroup]="loginForm" (submit)="login()">
        <div class="flex flex-column">
          <span class="p-input-icon-left w-full mb-4">
            <i class="pi pi-envelope"></i>
            <input
              id="email"
              type="text"
              formControlName="email"
              pInputText
              class="w-full md:w-25rem text-color-secondary surface-50 border-200"
              placeholder="Όνομα χρήστη"
            />
          </span>
          <span class="p-input-icon-left w-full mb-4">
            <i class="pi pi-lock"></i>
            <input
              id="password"
              type="password"
              formControlName="password"
              pInputText
              class="w-full md:w-25rem text-color-secondary surface-50 border-200"
              placeholder="Κωδικός"
              autocomplete="current-password"
            />
          </span>
          @if(errorMsg()){
          <span class="text-red-500 mb-4">{{ errorMsg() }}</span>
          }
          <button
            pButton
            severity="info"
            pRipple
            class="w-full mb-4"
            type="submit"
            [disabled]="loading"
          >
            <div
              class="flex flex-row justify-content-center align-items-center w-full"
            >
              @if(!loading){
              <span>Σύνδεση</span>
              }@else {
              <i class="pi pi-spin pi-spinner ml-2" style="font-size: 2rem"></i>
              }
            </div>
          </button>
        </div>
      </form>
      <div class="flex flex-wrap align-items-center pb-8 px-4">
        <h6 class="m-0 font-medium text-300" style="line-height: 17px">
          Copyright Ⓒ Covariance P.C.
        </h6>
      </div>
    </div>
  </div>
</div>
<p-toast baseZIndex="3000"></p-toast>
